import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum StartAssessmentStepNames {
    AssessmentForm = "ContactInfo",
    Checklist = "Checklist"
}

export interface StartAssessment {
    examineeId: number;
    locationId: number;
    assessmentFormId: number;
    // TODO: should not be optional
    upcomingAssessmentId?: number;
    isRetest?: boolean;
}

const emptyStartAssessment: StartAssessment = {
    examineeId: 0,
    locationId: 0,
    assessmentFormId: 0,
    upcomingAssessmentId: undefined,
    isRetest: false
};

export const initialState = emptyStartAssessment;

const startAssessmentSlice = createSlice({
    name: "startAssessment",
    initialState,
    reducers: {
        setStartAssessmentContext(state, action: PayloadAction<StartAssessment>) {
            state.examineeId = action.payload.examineeId;
            state.locationId = action.payload.locationId;
            state.assessmentFormId = action.payload.assessmentFormId;
            state.upcomingAssessmentId = action.payload.upcomingAssessmentId;
            state.isRetest = action.payload.isRetest;
        }
    }
});

export const { setStartAssessmentContext } = startAssessmentSlice.actions;

export default startAssessmentSlice.reducer;
